import React, { useState, useEffect, useRef } from "react";
import "./AllChatbot.css";
import oscarLogo from "../../images/Oscar.svg";
import { chatbotPostApi } from "../../Services/ChatBotApi/chatbotapi";
import { useDispatch } from "react-redux";
import GoogleAd from "../../Utils/GoogleAd";
import { StingKillInfo } from "../../Utils/LetterCase";

const AllChatbot = ({ communitName }) => {
  const [chatbotclick, setchatbotclick] = useState(false);
  const [userInput, setUserInput] = React.useState("");
  const [messages, setMessages] = React.useState([]);
  const [letterIndex, setLetterIndex] = useState(0);
  const [currentMessage, setCurrentMessage] = useState("");
  const [isDisplayingMessage, setIsDisplayingMessage] = useState(false);
  const messagesEndRef = useRef(null);
  const dispatch = useDispatch();
  const [placeholder, setPlaceholder] = useState("Ask OSCAR");
  const [randomId, setRandomId] = useState();
  const textareaRef = useRef(null);

  useEffect(() => {
    setRandomId(generateRandomNumber());
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 970.99) {
        setPlaceholder(
          "Meet OSCAR, your AI Owl Assistant-here to answer all your community questions with ease!"
        );
      } else {
        setPlaceholder("Ask OSCAR");
      }
    };

    // Call handleResize on component mount
    handleResize();

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const scrollToBottom = () => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    };

    // Scroll on new messages
    scrollToBottom();

    // Also scroll when messages are being typed out
    if (isDisplayingMessage) {
      scrollToBottom();
    }
  }, [messages, currentMessage, isDisplayingMessage]);

  useEffect(() => {
    if (isDisplayingMessage) {
      const message = messages[messages.length - 1].text;
      setCurrentMessage(message.slice(0, letterIndex));
    }
  }, [letterIndex, isDisplayingMessage, messages]);

  useEffect(() => {
    if (
      messages.length > 0 &&
      !messages.some((msg) => msg.loading) &&
      textareaRef.current
    ) {
      textareaRef.current.focus();
    }
  }, [messages]);

  const displayMessageLetterByLetter = (message) => {
    setCurrentMessage("");
    setLetterIndex(0);
    setIsDisplayingMessage(true);
    const interval = setInterval(() => {
      setLetterIndex((prevIndex) => {
        const newIndex = prevIndex + 5;
        if (newIndex >= message.length) {
          clearInterval(interval);
          setIsDisplayingMessage(false);
        }
        return newIndex;
      });
    }, 50);
  };

  function generateRandomNumber() {
    const randomNumber = Math.random();
    const scaledNumber = randomNumber * 900000 + 100000;
    const sixDigitNumber = Math.floor(scaledNumber);
    return sixDigitNumber;
  }
  const handlechatBotSubmit = async (e) => {
    if (userInput.trim()) {
      const userMessage = { type: "user", text: userInput, loading: false };
      const botPlaceholder = { type: "bot", text: "", loading: true }; // Bot's loading message

      setMessages((prev) => [...prev, userMessage, botPlaceholder]);
      setUserInput("");

      try {
        const response = await dispatch(
          chatbotPostApi({
            question: userInput,
            session_id: randomId,
            community_name: communitName === null ? null : communitName, // Send null if communityName is null
          })
        ).unwrap();

        if (response.response_code === 200) {
          setMessages((prev) =>
            prev.map((msg, index) =>
              index === prev.length - 1 // Update the last bot message
                ? { type: "bot", text: response.result, loading: false }
                : msg
            )
          );
          displayMessageLetterByLetter(response.result);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setMessages((prev) =>
          prev.map((msg, index) =>
            index === prev.length - 1
              ? {
                  ...msg,
                  text: "An error occurred. Please try again.",
                  loading: false,
                }
              : msg
          )
        );
      }
    }
  };

  const renderStaticMessage = (message) => {
    return (
      <div className="com_pass_ai_bx">
        <div
          className="com_pass_ai"
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        ></div>
      </div>
    );
  };

  const handleClose = () => {
    setchatbotclick(false);
    setUserInput("");
    setMessages([]);
  };

  return (
    <>
      <div>
        <div
          className={`chat_boat_media ${chatbotclick ? "d-block" : "d-none"}`}
        >
          <div className="chat_header">
            <div className="chat_header_flx">
              <div className="chat_boat_name justify-content-between">
                <div className="Oscar_header_message d-flex align-items-center gap-2">
                  <img
                    className="chatbot-logo"
                    src={oscarLogo}
                    alt="Oscar"
                    width="38"
                    height="38"
                  />
                  <h4 className="header-oscar">Oscar - Your Assistant</h4>
                </div>
                <div className="header-buttons" onClick={handleClose}>
                  <button className="refresh-button">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="25"
                      height="25"
                      x="0"
                      y="0"
                      viewBox="0 0 24 24"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      xmlSpace="preserve"
                      className=""
                    >
                      <g>
                        <path
                          d="M19.602 12.635a.99.99 0 0 0-1.134.844 6.402 6.402 0 0 1-1.83 3.618 6.506 6.506 0 0 1-9.192 0 6.507 6.507 0 0 1 0-9.192 6.414 6.414 0 0 1 3.503-1.8 6.187 6.187 0 0 1 1.848-.055 6.414 6.414 0 0 1 2.466.828l-1.302.223a1 1 0 1 0 .338 1.971l3.49-.596a1.002 1.002 0 0 0 .816-1.155l-.597-3.49a1 1 0 1 0-1.97.338l.156.919a8.423 8.423 0 0 0-3.17-1.025 8.102 8.102 0 0 0-2.428.074 8.379 8.379 0 0 0-4.564 2.354c-3.313 3.314-3.313 8.705 0 12.02a8.471 8.471 0 0 0 6.01 2.485 8.471 8.471 0 0 0 6.01-2.485 8.39 8.39 0 0 0 2.394-4.741 1 1 0 0 0-.843-1.135z"
                          fill="#e55426"
                          opacity="1"
                        />
                      </g>
                    </svg>
                  </button>
                  <button className="close-button" onClick={handleClose}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      width="17"
                      height="17"
                      x="0"
                      y="0"
                      viewBox="0 0 329.269 329"
                      style={{ enableBackground: "new 0 0 512 512" }}
                      xmlSpace="preserve"
                      className=""
                    >
                      <g>
                        <path
                          d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0"
                          fill="#e55426"
                          opacity="1"
                        />
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {messages.map((msg, index) =>
            msg.type === "bot" ? (
              <div key={msg + index} className="bot-parent">
                <div className="oscar-logo_chat">
                  <img
                    src={oscarLogo}
                    alt="oscar-chat"
                    width="30"
                    height="30"
                  />
                </div>
                {msg.loading ? (
                  <div className="loader"></div>
                ) : (
                  <div className="message bot-message padding-0">
                    <img src="/Oscar.svg" className="d-none" alt="" />
                    {index === 0 && !msg.option
                      ? renderStaticMessage(msg.text)
                      : isDisplayingMessage && index === messages.length - 1
                      ? StingKillInfo(currentMessage)
                      : StingKillInfo(msg.text)}
                  </div>
                )}
              </div>
            ) : (
              <div key={msg + index} className="user-message-parent">
                <div className="message user-message padding-0">
                  {StingKillInfo(msg.text)}
                </div>
              </div>
            )
          )}
          <div ref={messagesEndRef} style={{ height: "1px" }} />
          <GoogleAd
            adClient={process.env.REACT_APP_GOOGLE_AD_CLIENT}
            adSlot={process.env.REACT_APP_GOOGLE_AD_SLOT}
          />
        </div>
      </div>

      <div className="media_footer_flx">
        <div className="media_chat_icon textarea-icon">
          <img src={oscarLogo} alt="input-logo" width="60" height="60"></img>
        </div>
        <div className="media_input">
          <textarea
            ref={textareaRef}
            rows="1"
            placeholder={placeholder}
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                setchatbotclick(true);
                handlechatBotSubmit();
              }
            }}
            disabled={messages.some((msg) => msg.loading)}
          ></textarea>
        </div>
        <div
          className="send-btn-tabs"
          onClick={() => {
            setchatbotclick(true);
            handlechatBotSubmit(); // Call the function
          }}
        >
          <button
            type="button"
            className={`btn btn-sm ${userInput ? "active" : null}`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              version="1.1"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ enableBackground: "new 0 0 512 512" }}
              fillRule="evenodd"
              className=""
            >
              <g>
                <path
                  d="M11 5.414L5.707 10.707a1 1 0 0 1-1.414-1.414l7-7a.999.999 0 0 1 1.414 0l7 7a1 1 0 0 1-1.414 1.414L13 5.414V21a1 1 0 0 1-2 0z"
                  fill="#000000"
                  opacity="1"
                  data-original="#000000"
                />
              </g>
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default AllChatbot;
